module.exports = __webpack_public_path__ + "media/images/icons/country_flags/gf-16328213544e4ac5f3ee0187f8e87292.svg";